module.exports = __webpack_public_path__ + "img/logo_villach.d8089d88.png";